import React, { useState } from "react";

import { gameConceptBigIdLength, partnerCenterDashboardUrl } from "../../../../constants";
import { useStrings } from "../../../../localization/localizationHelpers";
import * as pageStyles from "../../GameConceptPage.module.css";
import * as styles from "./GameConceptStoreIdBanner.module.css";

type GameConceptStoreIdBannerProps = Readonly<{
  isSaving: boolean;
  hasError: boolean;
  onSave: (bigId: string) => void;
}>;

export const GameConceptStoreIdBanner = ({
  isSaving,
  hasError,
  onSave,
}: GameConceptStoreIdBannerProps) => {
  const [bigId, setBigId] = useState("");
  const [title, guidance, label, hint, save, saving, error, partnerCenter, createGameGuidance] =
    useStrings(
      "gameConceptStoreIdBannerTitle",
      "gameConceptStoreIdBannerGuidance",
      "gameConceptBigIdLabel",
      "gameConceptBigIdInvalidLength",
      "partnerSettingsSaveLabel",
      "savingButton",
      "gameConceptStoreIdSaveError",
      "partnerCenter",
      "gameConceptStoreIdCreateGameGuidance"
    );
  const [beforeLink, afterLink] = createGameGuidance.split("{0}");
  const normalizedId = bigId.trim();
  const isValid = normalizedId.length === gameConceptBigIdLength;

  return (
    <section className={styles.banner} aria-labelledby="add-store-id-title">
      <h2 id="add-store-id-title" className={styles.title}>
        {title}
      </h2>
      <p id="add-store-id-guidance">{guidance}</p>
      <p id="add-store-id-create-game">
        {beforeLink}
        <a
          href={partnerCenterDashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={pageStyles.idXboxRequirementLink}
        >
          {partnerCenter}
        </a>
        {afterLink}
      </p>
      <form
        aria-busy={isSaving}
        onSubmit={event => {
          event.preventDefault();
          if (isValid && !isSaving) {
            onSave(normalizedId);
          }
        }}
      >
        <label className={pageStyles.submissionBigIdLabel} htmlFor="approved-store-id">
          <strong>{label}</strong>
        </label>
        <p id="add-store-id-hint">{hint}</p>
        <input
          id="approved-store-id"
          type="text"
          className={pageStyles.submissionBigIdInput}
          value={bigId}
          onChange={event => setBigId(event.target.value)}
          required
          disabled={isSaving}
          aria-invalid={!!normalizedId && !isValid}
          aria-describedby="add-store-id-guidance add-store-id-create-game add-store-id-hint"
        />
        {hasError && <p role="alert">{error}</p>}
        <button
          type="submit"
          className={pageStyles.saveAndExitButton}
          disabled={!isValid || isSaving}
        >
          {isSaving ? saving : save}
        </button>
      </form>
    </section>
  );
};
